import { api } from "../utils/api";

const saveExternalLinkMenu = async data => {
  const res = await api.put("Settings/createCustomMenu", data);
  return res.data;
};

const getMenuLinks = async () => {
  const res = await api.get(`Settings/getCustomMenu`);
  return res.data;
};

const getCommunicationCategories = async () => {
  const res = await api.get("CommunicationCategoryCampuses/myCategories");
  return res.data;
};

const getAppDefaultPeriod = async () => {
  const res = await api.get("Settings/appDefaultPeriod");
  return res.data;
};

const saveAppDefaultPeriod = async data => {
  const res = await api.put("Settings/appDefaultPeriod", data);
  return res.data;
};

const saveCommunicationCategories = async data => {
  await api.post("CommunicationCategoryCampuses/newCategory", data);
};

const deleteCommunicationCategory = async id => {
  await api.delete(`CommunicationCategoryCampuses/disableCategory/${id}`);
};

export default {
  saveExternalLinkMenu,
  getMenuLinks,
  getCommunicationCategories,
  saveCommunicationCategories,
  deleteCommunicationCategory,
  getAppDefaultPeriod,
  saveAppDefaultPeriod
};
